module.exports = __webpack_public_path__ + "static/media/MobileAppimg.c31ed282.jpg";